import BreakingNews from "../../components/BreakingNews";
import NewsCard from "../../components/NewsCard";
import Profilecard from "../../components/Profilecard";
import LatestStories from "../../components/LatestStories.jsx";
import useNews from "../../hooks/useNews";
import AdBanner from "../../components/AdBanner";
import { getMediaBaseUrl } from "../../utils/backendUrl";

const World = () => {
  const { news, loading } = useNews({}); // dY"� ANY news (MP / CG / Hindi / Bundeli)

  const BASE_URL = getMediaBaseUrl();

  const resolveImage = (item) =>
    item?.thumbnail?.startsWith("http")
      ? item.thumbnail
      : `${BASE_URL}/uploads/news/${encodeURIComponent(item.thumbnail || "")}`;

  return (
    <div className="max-w-7xl mx-auto -mt-[65px] px-4 py-6 sm:mt-[0px]">
      <BreakingNews />

      <div className="mt-2 grid grid-cols-1 lg:grid-cols-12 gap-6">

        {/* ================= LEFT SIDE ================= */}
        <div className="lg:col-span-9 space-y-12">

          {/* 🔹 TOP NEWS (4 PROFILE CARDS – SAME AS BEFORE) */}
          {loading && <p>Loading...</p>}

          {!loading &&
            news.slice(0, 4).map((item) => (
              <section key={item.id}>
                <div className="lg:col-span-9">
                  <Profilecard data={item} />
                </div>
              </section>
            ))}

          {/* 🔹 GRID – 2 CARDS (SAME COUNT) */}
          <section>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {news.slice(4, 6).map((item) => (
                <NewsCard
                  key={item.id}
                  title={item.news_title}
                  image={resolveImage(item)}
                  category={item.category}
                  author={item.author || "Desk"}
                  date={item.createdAt}
                  readTime="2 Min read"
                  fullNews={item.description}
                  link={`/news/${item.id}`}
                />
              ))}
            </div>
          </section>

          {/* 🔹 GRID – 3 CARDS (SAME COUNT) */}
          <section>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {news.slice(6, 9).map((item) => (
                <NewsCard
                  key={item.id}
                  title={item.news_title}
                  image={resolveImage(item)}
                  category={item.category}
                  author={item.author || "Desk"}
                  date={item.createdAt}
                  readTime="3 Min read"
                  fullNews={item.description}
                  link={`/news/${item.id}`}
                    videoUrl={item.youtube_url}     // ✅ if exists

                />
              ))}
            </div>
          </section>

        </div>

        {/* ================= RIGHT SIDE ================= */}
        <aside className="lg:col-span-3">
          <div className="sticky top-[120px] space-y-4">
            <LatestStories />

            <AdBanner />
          </div>
        </aside>

      </div>
    </div>
  );
};

export default World;
